import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon",
  "use": "icon-icon-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-icon\"><defs><style>#icon-icon .a{fill:#8c8c8c;}</style></defs><g transform=\"translate(-65.982 -65.983)\"><path class=\"a\" d=\"M0,6a6,6,0,1,1,6,6A6.007,6.007,0,0,1,0,6ZM.861,6A5.139,5.139,0,1,0,6,.861,5.145,5.145,0,0,0,.861,6ZM5.57,9.013V5.139a.43.43,0,0,1,.861,0V9.013a.43.43,0,0,1-.861,0ZM5.354,3.2A.646.646,0,1,1,6,3.848.646.646,0,0,1,5.354,3.2Z\" transform=\"translate(65.982 65.983)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol